import { Component, Input, OnInit } from '@angular/core';
import { IInvitation } from '@app/models/signup';

@Component({
  selector: 'app-invitation-b2b-resend-success',
  templateUrl: './invitation-b2b-resend-success.component.html',
  styleUrls: ['./invitation-b2b-resend-success.component.scss']
})
export class InvitationB2BResendSuccessComponent {
  @Input() invitation: IInvitation;
  @Input() type: 'partner' | 'client';

  endpoints = window['ENDPOINTS'];
  account = window['CURRENT_ACCOUNT'];

  get managerLink() {
    return this.type === 'partner' ?
      `${this.endpoints?.manager}/v3/${this.account.id}/ng/accounts/reseller-space/manage-clients`
      : `${this.endpoints?.manager}/v3/${this.account.id}/ng/accounts/client-space/list`
      ;
  }
}
